import {
  createFetchCursorPaginatedActionForNamespace,
  createReducer,
  createFetchReducersWithPagination,
  createFetchSelectors
} from 'utils/reducers';

import {transformFiltersForStoreToFiltersForApi} from 'utils/filters';
import {transformCursorPaginationForStoreToPaginationForApi} from 'utils/pagination';

import {selectFilters, FILTERS} from 'ducks/filters';
import {selectPagination, PAGINATION} from 'ducks/pagination';

const createFetchActionWithCursorPagination = createFetchCursorPaginatedActionForNamespace(
  'bookings/tracker'
);

export const fetchBookingsForBookingTracker = createFetchActionWithCursorPagination(
  {
    name: 'FETCH_BOOKING_FOR_BOOKING_TRACKER',
    initialAction: ({locationRef}, extraActions = []) => ({
      payload: {
        locationRef,
        extraActions
      }
    }),
    stateKey: 'bookingsForBookingTracker',
    defaultStateValue: [],
    extraGetParamsSelectors: [
      state =>
        transformFiltersForStoreToFiltersForApi(
          selectFilters(state, FILTERS.BOOKING_TRACKER)
        ),
      state =>
        transformCursorPaginationForStoreToPaginationForApi(
          selectPagination(state, PAGINATION.BOOKING_TRACKER)
        )
    ],
    paginationNamespace: PAGINATION.BOOKING_TRACKER
  }
);

const fetchBookingsForBookingTrackerSelector = createFetchSelectors(
  fetchBookingsForBookingTracker
);
export const selectBookingsForBookingTracker =
  fetchBookingsForBookingTrackerSelector.data;
export const selectBookingsForBookingTrackerLoading =
  fetchBookingsForBookingTrackerSelector.isLoading;

const fetchReducers = createReducer(
  {},
  {
    ...createFetchReducersWithPagination(fetchBookingsForBookingTracker)
  }
);

const reducer = (state = {}, action) => {
  const newState = fetchReducers(state, action);

  switch (action.type) {
    default:
      return newState;
  }
};

export default reducer;

export {default as fetchBookingsForBookingTrackerSaga} from './saga';
